import ReactDOM from 'react-dom/client';
import { Routing } from './common/routes/Routing';
import './index.css';
import reportWebVitals from './reportWebVitals';

import nativeBridgePkg from '@airtel-lego/native-app-bridge/package.json';
import { initialiseSentry } from '@airtel-lego/sentry';
import artistPkg from '@airtel/air-artist/package.json';
import designSysPkg from '@airtel/air-design-system/package.json';
import widgetLibPkg from '@airtel/air-widgets-library/package.json';

console.table({
   'air-widgets-library': widgetLibPkg.version,
   'air-design-system': designSysPkg.version,
   'air-artist': artistPkg.version,
   'native-bridge': nativeBridgePkg.version,
});

/*
 * initialise sentry sdk
 */
initialiseSentry({
   dsn: process.env.REACT_APP_SENTRY_DSN,
   release: `${process.env.REACT_APP_NAME}@${process.env.REACT_APP_VERSION}`,
   environment: process.env.REACT_APP_SENTRY_ENV,
   tracesSampleRate: 1,
   isDebugMode: true,
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// Remove strict mode for testing rerenders
// for more details visit https://github.com/facebook/react/issues/24502
root.render(<Routing />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();